const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeRef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.7314mm",
    height: "6.7314mm",
    viewBox: "0 0 6.7314 6.7314",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.146 -81.165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1 0 0 1.1 -3.7403 -8.4531)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 -13.383 -27.108)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 0.12003
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.615 83.876h.9954",
    style: {
      fill: "none",
      strokeWidth: 0.27107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.189 83.398.42133.47772-.42133.47772",
    style: {
      fill: "none",
      strokeWidth: 0.27107
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 36.438725,
    y: 86.049683,
    style: {
      fill: "#000000",
      fontFamily: "Univers",
      fontSize: "4.1761px",
      letterSpacing: 0,
      lineHeight: 0,
      strokeWidth: ".033408px",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36.438725,
    y: 86.049683,
    style: {
      fill: "#000000",
      fontFamily: "Figtree",
      strokeWidth: ".033408px"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    x: 40.658585,
    y: 86.049683,
    style: {
      fill: "#000000",
      fontFamily: "Univers",
      fontSize: "4.1761px",
      letterSpacing: 0,
      lineHeight: 0,
      strokeWidth: ".033408px",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.658585,
    y: 86.049683,
    style: {
      fill: "#000000",
      fontFamily: "Figtree",
      strokeWidth: ".033408px"
    }
  }, "1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeRef);
export default __webpack_public_path__ + "static/media/icon_type_ref.d9538b0716d9fc47caa4941e9865711e.svg";
export { ForwardRef as ReactComponent };